import { render, staticRenderFns } from "./PriceModelFormModal.vue?vue&type=template&id=7c89f0ee"
import script from "./PriceModelFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceModelFormModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c89f0ee')) {
      api.createRecord('7c89f0ee', component.options)
    } else {
      api.reload('7c89f0ee', component.options)
    }
    module.hot.accept("./PriceModelFormModal.vue?vue&type=template&id=7c89f0ee", function () {
      api.rerender('7c89f0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/PriceModelFormModal.vue"
export default component.exports